export default "#version 300 es\n#ifdef GL_ES\nprecision highp float;\n#endif\n\nin vec4 rgba;\n\nout vec4 fragColor;\n\nvoid main() {\n  fragColor = rgba;\n}"